import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import emoji from './emoji.json';
import generalSettings from './generalSettings.json';
import general from './general.json';
import components from './components.json';
import helpCenter from './helpCenter.json';
import iaAgents from './iaAgents.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import customRole from './customRole.json';
import sla from './sla.json';
import datePicker from './datePicker.json';
import inbox from './inbox.json';
import crm from './crm.json';
import agenda from './agenda.json';
import capacityAgenda from './capacityAgenda.json';
import forwardMessage from './forwardMessage.json';
import chatGroup from './chatGroup.json';
import customMessagesMgmt from './customMessagesMgmt.json';
import addresses from './addresses.json';
import products from './products.json';
import medicalRecord from './medicalRecord.json';
import userManagement from './userManagement.json';
import patientManagement from './patientManagement.json';
import managementCharts from './management_charts.json';

export default {
  ...components,
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...emoji,
  ...generalSettings,
  ...general,
  ...helpCenter,
  ...iaAgents,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...teamsSettings,
  ...whatsappTemplates,
  ...customRole,
  ...sla,
  ...datePicker,
  ...inbox,
  ...crm,
  ...agenda,
  ...capacityAgenda,
  ...forwardMessage,
  ...chatGroup,
  ...customMessagesMgmt,
  ...addresses,
  ...products,
  ...medicalRecord,
  ...userManagement,
  ...patientManagement,
  ...managementCharts,
};
